import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="catalog--lightbox"
// Provides image lightbox with keyboard navigation (arrows, escape)
export default class extends Controller {
  static targets = ["overlay", "slide", "caption", "downloadLink"]
  static values = {
    index: { type: Number, default: 0 },
  }

  open({ params: { idx } }) {
    this.indexValue = idx
    this.showSlide()
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
    document.body.style.overflow = ""
  }

  disconnect() {
    document.body.style.overflow = ""
  }

  closeBackground(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  next() {
    if (!this.hasSlideTarget) return
    this.indexValue = (this.indexValue + 1) % this.slideTargets.length
    this.showSlide()
  }

  prev() {
    if (!this.hasSlideTarget) return
    this.indexValue =
      (this.indexValue - 1 + this.slideTargets.length) %
      this.slideTargets.length
    this.showSlide()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  // Private

  showSlide() {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("hidden", i !== this.indexValue)
    })

    const current = this.slideTargets[this.indexValue]
    const filename = current?.getAttribute("alt") || ""

    if (this.hasCaptionTarget) {
      this.captionTarget.textContent = `${this.indexValue + 1} / ${this.slideTargets.length} — ${filename}`
    }

    // Optional download affordance — only when the view wires a downloadLink
    // target and slides carry a data-download-url. Keeps the catalog gallery
    // (which has neither) untouched.
    if (this.hasDownloadLinkTarget) {
      const url = current?.dataset.downloadUrl
      if (url) {
        this.downloadLinkTarget.setAttribute("href", url)
        this.downloadLinkTarget.setAttribute("download", filename)
        this.downloadLinkTarget.classList.remove("hidden")
      } else {
        this.downloadLinkTarget.classList.add("hidden")
      }
    }
  }
}
